module.exports = __webpack_public_path__ + "static/media/notification-svgrepo-com (3).13570843.svg";